class WishlistView extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.gridViewContainer = this.querySelector('[data-wishlist-items-grid-display]');
            this.listPaginationButtons = document.getElementById('wishlist-paginate');
            this.viewCols = [...this.querySelectorAll('[data-col]')];

            this.wlpaggingContainer = document.getElementById('wishlist-paginate');
            this.wishlistContainer = this.closest('[data-wishlist-container]');
            this.wishlistFooter = document.querySelector('[data-wishlist-footer]');

            this.viewCols.forEach(viewCol => {
                viewCol.addEventListener('click', this.onViewColClick.bind(this));
            })

            window.addEventListener('resize', this.onResize.bind(this));

            this.initWishlistPage();
        }

        getMaxColOnSize() {
            const availableViewCols = this.viewCols.filter(view => {
                return getComputedStyle(view, null).getPropertyValue('display') === 'inline-block';
            }).map(view => Number(view.dataset.col))

            return availableViewCols[availableViewCols.length - 1]
        }

        onResize() {
            const selectedCol = Number(this.querySelector('[data-col].active').dataset.col);
            const maxColNum = this.getMaxColOnSize();

            if (selectedCol > maxColNum) {
                this.viewCols.find(viewCol => Number(viewCol.dataset.col) === maxColNum).click();
            } 
        }

        onViewColClick(e) {
            const viewCol = e.target;
            const col = Number(viewCol.dataset.col); 

            this.switchViewListGrid(col === 1)
            this.setPaginationAndHeadingView(col === 1);
            this.paginationForList(col === 1)
            this.setGridColumns(col)
            this.setActiveViewCol(viewCol)
        }       

        switchViewListGrid(isList) {
            if (isList) {
                this.gridViewContainer.classList.add('productList');
                return 
            }

            this.gridViewContainer.classList.remove('productList');
        }

        setGridColumns(col) {
            this.gridViewContainer.style.setProperty('--grid-columns', col);
        }

        setActiveViewCol(colElement) {
            this.viewCols.forEach(col => col.classList.remove('active'));
            colElement.classList.add('active');
        }

        setPaginationAndHeadingView(isList) {
            if (isList) {
                this.listPaginationButtons.style.display = 'flex';
                return;
            }

            this.listPaginationButtons.style.display = 'none';
        }   

        paginationForList(isList) {
            const items = this.gridViewContainer.querySelectorAll('.product');
            const currentPage = Number(this.listPaginationButtons.dataset.currentPage);

            if (isList && currentPage) {
                items.forEach((item, index) => {
                    if (index >= (currentPage -1 ) * 3 && index < currentPage * 3) {
                        $(item).show();
                    } else {
                        $(item).hide();
                    }
                })
            } 
            else {
                items.forEach((item, index) => {
                    $(item).show();
                })  
            }
        }  

        // For building wishlist page
        async initWishlistPage (){
            if (typeof(Storage) !== 'undefined') {
                const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

                if (wishlistList.length > 0) {
                    try {
                        await Promise.all(wishlistList.map((handle, index) => this.setProductForWishlistPage(handle, index, wishlistList.length)));
                        this.updateShareWishlistViaMail();
                        window.sharedFunctions?.calculateTranslateYHeight();
                        this.calculateCard06Padding();

                        this.gridViewContainer.classList.add('is-loaded');
                        this.wishlistPagination();
                        this.removeAndAddPaginationButtonEvents();
                        this.setDefaultLayout();

                        document.addEventListener('updatepagination', this.wishlistPagination.bind(this));
                        document.addEventListener('updatewishlistmail', this.updateShareWishlistViaMail.bind(this));
                        document.addEventListener('addwishlistitem', async (e) => {
                            const handle = e.detail.handle;
                            await this.setProductForWishlistPage(handle);
                            this.wishlistPagination();
                        });
                    } catch(err) {
                        console.error(err);
                        showWarning(err.message);
                    }
                } else {    
                    this.wishlistContainer.classList.add('is-empty').innerHTML = `\
                        <div class="wishlist-content-empty text-center">\
                            <span class="wishlist-content-text">${window.wishlist.empty}</span>\
                            <div class="wishlist-content-actions">\
                                <a class="button button-2 button-continue" href="${window.routes.collection_all}">\
                                    ${window.wishlist.continue_shopping}\
                                </a>\
                            </div>\
                        </div>\
                    ` ;

                    this.wishlistFooter.style.display = 'none';
                }   
            } else {
                alert('Sorry! No web storage support..');
            }
        }

        setDefaultLayout() {
            const defaultDesktopCol = parseInt(this.dataset.defaultDesktopCol);
            const maxCol = this.getMaxColOnSize();
            const defaultCol = defaultDesktopCol <= maxCol ? defaultDesktopCol : maxCol;
                
            this.viewCols.find(viewCol => parseInt(viewCol.dataset.col) === defaultCol ).click();
        }

        async setProductForWishlistPage(handle, index, wishlistListLength) {
            try {
                const res = await fetch(`${window.routes.root}/products/${handle}?view=ajax_wishlist_card`)
                const data = await res.text();

                const productHTML = new DOMParser().parseFromString(data, 'text/html').getElementsByClassName('product')[0];

                this.gridViewContainer.appendChild(productHTML);
                productHTML.dataset.productHandle = handle;

                const item = this.wishlistContainer.querySelector(`[data-wishlist][data-wishlist-handle="${handle}"]`);

                if (item != null) {
                    item.classList.add('wishlist-added');
                    item.querySelector('.text').textContent = window.wishlist.added;
                    item.classList.add('is-in-grid');
                    productHTML.dataset.wishlistAdded = `wishlist-${item.dataset.productId}`;
                    item.addEventListener('click', e => {
                        e.target.closest('.product').remove();
                    })
                    
                    if (index >= 3) {
                        item.closest('.product').display = 'none';
                    }
                }

                
            } catch (err) {
                console.error(err);
                showWarning(err.message);
            }
        }

        static getPaginationButton(totalPages) {
            let paggingTpl;

            if (window.pagination.style === 1) {
                paggingTpl = '<li class="pagination-arrow prev disabled style-1"><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"><svg class="icon thin-arrow" viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></span></a></li>';
            } else if (window.pagination.style === 2) {
                paggingTpl = '<li class="pagination-arrow prev disabled style-2"><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></span></a></li>';
            } else {
                paggingTpl = '<li class="pagination-arrow prev disabled style-3"><a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg><span class="arrow-text">'+ window.pagination.prev +'</span></a></li>';
            }

            for (let i = 0; i < totalPages; i++) {
                const pageNum = i + 1;
                if (i === 0) paggingTpl += '<li class="active pagination-num"><a class="pagination__item link" data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
                else paggingTpl += '<li class="pagination-num"><a class="pagination__item link" data-page="' + pageNum + '" href="'+ pageNum +'" title="'+ pageNum +'">' + pageNum + '</a></li>'
            }

            if (window.pagination.style === 1) {
                paggingTpl += '<li class="pagination-arrow next style-1"><a href="#" class="pagination__item pagination__item--next pagination__item-arrow link"><svg class="icon thin-arrow" viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></span></a></li>';
            } else if (window.pagination.style === 2) {
                paggingTpl += '<li class="pagination-arrow next style-2"><a href="#" class="pagination__item pagination__item--next pagination__item-arrow link"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></span></a></li>';
            } else {
                paggingTpl += '<li class="pagination-arrow next style-3"><a href="#" class="pagination__item pagination__item--next pagination__item-arrow link"><span class="arrow-text">' + window.pagination.next +'</span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></svg></span></a></li>';
            }

            return paggingTpl;
        }

        wishlistPagination() {
            const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
            
            this.wlpaggingContainer.setAttribute('data-current-page', 1);
            while (this.wlpaggingContainer.firstChild) {
                this.wlpaggingContainer.removeChild(this.wlpaggingContainer.firstChild);
            }

            if (!this.gridViewContainer.classList.contains('productList')) return;
            this.gridViewContainer.classList.remove('is-loaded')

            this.totalPages = Math.ceil(wishlistList.filter(item => item != null).length / 3);

            if (this.totalPages <= 1) {
                [...this.gridViewContainer.children].forEach(child => {
                    child.style.display = 'block';
                });
                this.gridViewContainer.classList.add('is-loaded');
                return;
            }

            const paggingTpl = WishlistView.getPaginationButton(this.totalPages);
            this.wlpaggingContainer.insertAdjacentHTML('beforeend', paggingTpl);

            this.paginateToPages();

            this.gridViewContainer.classList.add('is-loaded');
        }   

        paginateToPages(nextPageNumber = null) {
            const children = [...this.gridViewContainer.children];

            if (nextPageNumber == null) {
                children.forEach((element, index) => {
                    if (index >= 3) {
                        element.style.display = 'none';
                    }
                    else {
                        element.style.display = 'block';
                    }   
                })
                return;
            } 

            children.forEach((element, index) => {
                if (index >= (nextPageNumber - 1) * 3 && index < nextPageNumber * 3) {
                    element.style.display = 'block';
                }
                else {
                    element.style.display = 'none';
                }   
            })

            if (nextPageNumber === 1) {
                this.wlpaggingContainer.querySelector('.prev').classList.add('disabled');
                this.wlpaggingContainer.querySelector('.next').classList.remove('disabled');
            }
            else if (nextPageNumber === this.totalPages) {
                this.wlpaggingContainer.querySelector('.next').classList.add('disabled');
                this.wlpaggingContainer.querySelector('.prev').classList.remove('disabled');
            }
            else {
                this.wlpaggingContainer.querySelector('.prev').classList.remove('disabled');
                this.wlpaggingContainer.querySelector('.next').classList.remove('disabled');
            }
        }
        
        removeAndAddPaginationButtonEvents() {
            $(this.wlpaggingContainer).off('click.wl-pagging').on('click.wl-pagging', 'li a', e => {
                e.preventDefault();
                const isPrev = e.currentTarget.parentElement.classList.contains('prev');
                const isNext = e.currentTarget.parentElement.classList.contains('next');
                let pageNumber = parseInt(e.currentTarget.dataset.page);

                const currentButton = e.currentTarget.closest('#wishlist-paginate').querySelector('.active');
                let curPage = parseInt(currentButton.querySelector('.link').dataset.page);

                if (isPrev) {
                    pageNumber = curPage - 1;
                    if (pageNumber <= 0) pageNumber = 1;
                }
                
                if (isNext) {
                    pageNumber = curPage + 1;
                    if (pageNumber > this.totalPages) pageNumber = this.totalPages;
                }

                this.wlpaggingContainer.dataset.currentPage = pageNumber;
                this.paginateToPages(pageNumber);

                currentButton.classList.remove('active');
                this.wlpaggingContainer.querySelector(`[data-page="${pageNumber}"]`).parentElement.classList.add('active');
            });
        }

        updateShareWishlistViaMail() {
            const regex = /(<([^>]+)>)/ig;
            const addedItems = document.querySelectorAll('[data-wishlist-added]');

            const shareLinkElement = document.querySelector('[data-wishlist-share]');
            let href = 'mailto:?subject= Wish List&body=';

            addedItems.forEach((item, index) => {
                const price = item.querySelector('.price__sale .price__last .price-item')?.textContent || item.querySelector('.price__regular .price__last .price-item')?.textContent;
                const title = item.querySelector('[data-product-title]')?.dataset.productTitle;
                const url = item.querySelector('[data-product-url]')?.dataset.productUrl;

                href += encodeURIComponent(title + '\nPrice: ' + price?.replace(regex, '') + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + url +'\n\n');
            })

            shareLinkElement.href = href;
        }

        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const cardAction = document.querySelector('.card .card-action.card-grid__hidden');

            if (cardAction != undefined) {
                cardAction.classList.remove('card-grid__hidden');
                const padding = cardAction.scrollHeight;
                document.querySelector('[data-wishlist-items-grid-display]').style.setProperty('--card-06-padding', padding + 'px');
                cardAction.classList.add('card-grid__hidden');
            }
        }
    }
    
    customElements.define('wishlist-view', WishlistView);